import { MDCTextField, MDCTextFieldFoundation } from '@material/textfield'
import Block from '../../block'

export default class MdcTextField extends Block {
    static title = 'mdc-text-field--webiq'

    init() {
        this.field = new MDCTextField(this.element)
        this.foundation = new MDCTextFieldFoundation(this.element)
        this.foundation.init()

        this.autofillChecks = 0

        const selectors = '.mdc-text-field__input, .mdc-text-field__textarea'

        if (
            this.element
                .querySelector(selectors)
                .getAttribute('autofill') !== 'off'
        ) {
            window.setTimeout(() => this.checkAutofill(), 300)
        }

        if (this.element.querySelector(selectors).value) {
            this.floatLabel(true)
        }
    }

    floatLabel(bool) {
        this.field.foundation_.notchOutline(bool)
        this.field.foundation_.adapter_.floatLabel(bool)
    }

    checkAutofill() {
        try {
            if (this.element.querySelector('input:-webkit-autofill') || this.getElement('input:-webkit-autofill')) {
                this.floatLabel(true)
            } else if (this.autofillChecks < 10) {
                this.autofillChecks = this.autofillChecks + 1
                window.setTimeout(() => this.checkAutofill(), 300)
            }
        } catch (e) {
            
        }
    }
}